import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../Utils/apiClient';

// ── Получить избранных мастеров пользователя ─────────────────────────────────
export const fetchFavorites = createAsyncThunk(
  'favorites/fetchFavorites',
  async (userId, { rejectWithValue }) => {
    try {
      const res = await apiRequest('GET', `/favorites/${userId}`);
      return res?.data?.favorites || res?.favorites || [];
    } catch (err) {
      return rejectWithValue(err.message || 'Fetch error');
    }
  }
);

// ── Добавить мастера в избранное ─────────────────────────────────────────────
export const addFavorite = createAsyncThunk(
  'favorites/addFavorite',
  async ({ userId, masterId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest('POST', '/favorites', { userId, masterId });
      return res?.data?.favorite || res?.favorite || null;
    } catch (err) {
      // 409 — уже в избранном, не считаем ошибкой
      if (err.message?.includes('409')) return null;
      return rejectWithValue(err.message || 'Add error');
    }
  }
);

// ── Удалить мастера из избранного ────────────────────────────────────────────
export const removeFavorite = createAsyncThunk(
  'favorites/removeFavorite',
  async ({ userId, masterId }, { rejectWithValue }) => {
    try {
      await apiRequest('DELETE', `/favorites/${userId}/${masterId}`);
      return masterId;
    } catch (err) {
      return rejectWithValue(err.message || 'Remove error');
    }
  }
);

// ── Поиск мастера по имени/фамилии ───────────────────────────────────────────
export const searchMasterByName = createAsyncThunk(
  'favorites/searchMasterByName',
  async (query, { rejectWithValue }) => {
    if (!query || query.trim().length < 2) return [];
    try {
      const res = await apiRequest('GET', `/favorites/search?name=${encodeURIComponent(query.trim())}`);
      return res?.data?.masters || res?.masters || [];
    } catch (err) {
      return rejectWithValue(err.message || 'Search error');
    }
  }
);

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState: {
    list:          [],
    searchResults: [],
    loading:       false,
    searchLoading: false,
    error:         null,
  },
  reducers: {
    clearSearch: (state) => {
      state.searchResults = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavorites.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(fetchFavorites.fulfilled, (state, action) => { state.list = action.payload; state.loading = false; })
      .addCase(fetchFavorites.rejected,  (state, action) => { state.error = action.payload; state.loading = false; })

      .addCase(addFavorite.fulfilled, (state, action) => {
        if (action.payload) state.list.unshift(action.payload);
      })

      .addCase(removeFavorite.fulfilled, (state, action) => {
        state.list = state.list.filter(f => f.masterId !== action.payload);
      })

      .addCase(searchMasterByName.pending,   (state) => { state.searchLoading = true; })
      .addCase(searchMasterByName.fulfilled, (state, action) => { state.searchResults = action.payload; state.searchLoading = false; })
      .addCase(searchMasterByName.rejected,  (state) => { state.searchResults = []; state.searchLoading = false; });
  },
});

export const { clearSearch } = favoritesSlice.actions;
export default favoritesSlice.reducer;